import { useStytch } from '../GlobalContextProvider.mjs';
import { useMutate } from '../utils.mjs';

const useSsoDiscoveryConnection = ()=>{
    const stytch = useStytch();
    return useMutate('stytch.sso.discoverConnections', async (_key, { arg: { emailAddress } })=>await stytch.sso.discoverConnections(emailAddress), {
        throwOnError: true
    });
};

export { useSsoDiscoveryConnection };
//# sourceMappingURL=useSsoDiscoveryConnection.mjs.map
